import React from 'react';

const ProductSummarySchedule = ({item, plan}) => (
  <section>
    <h3 className="drawr-travel__title">ツアースケジュール</h3>
    {item.schedule &&
    <div className="drawr-travel__schedule">
      {item.schedule.map((schedule, idx) => (
        <div className="drawr-travel__schedule_item" key={idx}>
          {schedule.time}: {schedule.title}
        </div>
      ))}
    </div>
    }
    <a href={`${item.url}#section-schedule`} className="btn btn-block btn-outline-primary btn-sm mb-3">詳しいスケジュールを見る</a>
  </section>
);

export default ProductSummarySchedule;



// WEBPACK FOOTER //
// ./src/pages/travel/components/ProductSummarySchedule.js